export default {"src":"/_next/static/media/lib_resource.3b46d8cf.svg","height":491,"width":521,"blurWidth":0,"blurHeight":0};